<template>
  <div class="edit-list-container">
    <BaseChip
      v-for="(item, idx) in parsedItems"
      :key="idx"
      :label="item"
      class="custom-chip"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import BaseChip from '@/components/BaseComponents/BaseChip.vue';

const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean, Array, Date, Object],
    default: null
  },
  readOnly: {
    type: Boolean,
    default: false
  },
  singleLine: {
    type: Boolean,
    default: false
  },
  autoSave: {
    type: Boolean,
    default: true
  },
  rowId: { type: [String, Number], default: '' },
  header: { type: Object, required: true }
});

defineEmits(['update:modelValue']);

const parsedItems = computed(() => {
  if (!props.modelValue) {
    return [];
  }

  // Backend sender ColumnData objekt med Value som array
  if (props.modelValue && typeof props.modelValue === 'object' && 'value' in props.modelValue) {
    return Array.isArray(props.modelValue.value) ? props.modelValue.value : [];
  }

  // Fallback: hvis det fortsatt er en array direkte
  return Array.isArray(props.modelValue) ? props.modelValue : [];
});
</script>

<style scoped>
.edit-list-container {
  position: relative;
}

.custom-chip {
  margin: 0.25rem;
}

</style>
